// extracted by mini-css-extract-plugin
export default {"holder":"gallery_holder__pOThq"};